/**
 * Common
 *
 * Scripts for all pages.
 *
 * @since 1.0.0
 */

// import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on all pages
    const hamburger = document.querySelector(".open-mobile");

    hamburger?.addEventListener("click", toggleHamburger);

    function toggleHamburger() {
      hamburger?.classList.toggle("open");
      document.querySelector(".nav-mobile")?.classList.toggle("showClose");
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
